import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoan } from 'services/loans/manager'

export default function useSetNewLoans() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyFirst) => {
            return ManagementAddNewLoan(payload)
        },
        onSuccess: (response, variables) => {
            navigate('/loans/add-new/management/final', {
                state: {
                    payload: variables,
                    response: response,
                    loan_demand: state?.loan_demand,
                },
            })
        },
        onError: (error) => {
            //@ts-ignore
            if (error.response.data[0] === 'Interest cannot be more than 4%.') {
                toast.error('میزان کارمزد نباید بیش از 4 درصد مقدار وام باشد')
            } else {
                toast.error('خطایی رخ داده!')
            }
        },
    })

    return { isLoading, mutate }
}
